import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import FingerprintIcon from "@mui/icons-material/Fingerprint";

interface BiometricPromptProps {
  open: boolean;
  onActivate: () => void;
  onDismiss: () => void;
  isLoading?: boolean;
}

/**
 * Dialog que pergunta ao usuário se deseja ativar desbloqueio por biometria.
 * Exibido após login bem-sucedido no PWA.
 */
const BiometricPrompt: React.FC<BiometricPromptProps> = ({
  open,
  onActivate,
  onDismiss,
  isLoading = false,
}) => {
  return (
    <Dialog open={open} onClose={onDismiss} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <FingerprintIcon color="primary" />
        Desbloqueio rápido
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Deseja ativar o desbloqueio por impressão digital ou reconhecimento facial?
          Assim você não precisará digitar a senha toda vez que abrir o app.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onDismiss} disabled={isLoading}>
          Agora não
        </Button>
        <Button
          onClick={onActivate}
          variant="contained"
          disabled={isLoading}
          startIcon={<FingerprintIcon />}
        >
          Ativar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BiometricPrompt;
